import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  assignWorkPlanPro,
  emptyUnassignPro,
  loadUnassignPro,
} from "../../../Redux/Actions/ActionWorkPlanProduct";
import InnerLoader from "../../General/InnerLoader";
import useClickOutside from "../../../useClickOutside";
import { CheckFont } from "../../General/GeneralComponent/CheckLang";

function MultiSelectStock({ work_plan_id, t, langmiamed, setOpen }) {
  const [openInternet, setopenInternet] = useState(false);
  const [batch, setBatch] = useState(null);
  const [searchTerm, setSearchTerm] = useState(""); // State for the search term
  const [arrID, setarrID] = useState([]);
  const [showQuantity, setShowQuantity] = useState({});
  const [Load, setLoad] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const Unassign_product = useSelector(
    (state) => state.Product_WorkPlan.Unassign_product
  );
  const loadingUnassign_product = useSelector(
    (state) => state.Product_WorkPlan.loadingUnassign_product
  );

  useEffect(() => {
    dispatch(loadUnassignPro(work_plan_id));
    return () => {
      dispatch(emptyUnassignPro());
    };
  }, [dispatch, work_plan_id]);

  const handleCheckboxChange = (productId) => {
    const isProductSelected = arrID.some((item) => item.id === productId);

    if (isProductSelected) {
      setarrID((prevArr) => prevArr.filter((item) => item.id !== productId));
      setShowQuantity((prevShowQuantity) => ({
        ...prevShowQuantity,
        [productId]: false,
      }));
    } else {
      setarrID((prevArr) => [...prevArr, { id: productId, quantity: 0 }]);
      setShowQuantity((prevShowQuantity) => ({
        ...prevShowQuantity,
        [productId]: true,
      }));
    }
  };

  const handleQuantityChange = (productId, newQuantity) => {
    setarrID((prevArr) =>
      prevArr.map((item) =>
        item.id === productId ? { ...item, quantity: newQuantity } : item
      )
    );
  };

  const handleBatchChange = (productId, batch) => {
    setarrID((prevArr) =>
      prevArr.map((item) =>
        item.id === productId ? { ...item, batch_number: batch } : item
      )
    );
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  let domNode = useClickOutside(() => {
    setOpen(false);
  });

  const print = (e) => {
    e.preventDefault();
    dispatch(
      assignWorkPlanPro(work_plan_id, arrID, navigate, setopenInternet, setLoad)
    );
  };

  // Filtered Products based on search
  const filteredProducts = Unassign_product.filter((product) =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div
      className={`div_assign_stock ${
        langmiamed === "ar" ? "div_assign_stock_ar" : "div_assign_stock_en"
      }`}
      ref={domNode}
      dir={langmiamed === "ar" ? "rtl" : "ltr"}
    >
      <input
        type="text"
        placeholder={t("search")}
        className="search_input"
        value={searchTerm}
        onChange={handleSearchChange}
      />
      {loadingUnassign_product === false ? (
        filteredProducts.map((pp) => {
          return (
            <div key={pp.id}>
              <div className="div_assign_stock_row">
                <input
                  type="checkbox"
                  onChange={() => handleCheckboxChange(pp.id)}
                />
                <span
                  style={{
                    color: pp.color || "black",
                    fontFamily: CheckFont(pp.name),
                  }}
                >
                  {pp.name}
                </span>
              </div>
              {showQuantity[pp.id] && (
                <>
                  <input
                    type="text"
                    className="quantity_stock"
                    placeholder={t("quantity")}
                    onChange={(e) =>
                      handleQuantityChange(pp.id, parseInt(e.target.value, 10))
                    }
                  />
                  <input
                    type="text"
                    className="quantity_stock"
                    placeholder={t("batch_number")}
                    onChange={(e) => handleBatchChange(pp.id, e.target.value)}
                  />
                </>
              )}
            </div>
          );
        })
      ) : (
        <div className="div_loadd">
          <InnerLoader />
        </div>
      )}
      <button onClick={print}>{Load ? "Loading ..." : t("save")}</button>
    </div>
  );
}

export default MultiSelectStock;
